import { render, staticRenderFns } from "./location-and-lot-adjustment.vue?vue&type=template&id=14221f31&scoped=true"
import script from "./location-and-lot-adjustment.vue?vue&type=script&lang=js"
export * from "./location-and-lot-adjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14221f31",
  null
  
)

export default component.exports